<template>
  <div class="i-dropdown" :class="{'disabled': disabled}">
    <div v-if="label" class="field-label">
      {{ label }}
    </div>

    <multiselect
      ref="dropdown"
      label="label"
      :class="{[textTransform]: true}"
      :modelValue="selectedValue"
      :options="options"
      :placeholder="placeholder"
      :multiple="multiSelect"
      :disabled="disabled"
      :allow-empty="allowEmpty"
      :searchable="searchable"
      :taggable="taggable"
      @select="onSelect"
      @remove="onRemove"
      @tag="addTag"
      @search-change="scrollHighlightedIntoView"
      @keydown="onKeydown"
    >
      <template v-slot:clear>
        <font-awesome-icon
          v-if="selectedValue && clearable"
          class="clear-btn btn-icon icon-clickable"
          icon="fa-duotone fa-xmark"
          @click.stop="clearAll()"
        />
      </template>
      <template #noOptions>
        {{ $t('common.listIsEmpty') }}
      </template>
      <template #noResult>
        {{ $t('common.noElementsFound') }}
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: "IDropdown",
  emits: ['update:modelValue', 'input'],
  components: {Multiselect},
  props: {
    options: {
      type: Array
    },
    modelValue: {},
    label: {
      type: String,
      default: 'Choose'
    },
    placeholder: {
      type: String,
      default: 'Choose'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: false
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    textTransform: {
      type: String,
      default: ''
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    taggable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selected: null
    }
  },

  computed: {
    selectedValue() {
      if (this.multiSelect) {
        return this.options?.filter(option => this.modelValue?.includes((option.value)))
      }

      return this.options?.find(option => option?.value === this.modelValue)
    }
  },
  methods: {
    emitValue(value) {
      this.$emit('update:modelValue', value);
      this.$emit('input', value);
    },
    onSelect(data) {
      let dataValue
      if (this.multiSelect) {
        dataValue = [...this.modelValue || [], data.value]
      } else {
        dataValue = data.value
      }
      this.emitValue(dataValue)
    },

    clearAll() {
      this.emitValue(null)
    },

    onRemove(data) {
      if (this.multiSelect) {
        let values = this.modelValue.filter(val => data.value !== val)
        if (values.length === 0) {
          this.emitValue(null)
        } else {
          this.emitValue(values)
        }
      } else {
        this.emitValue(null)
      }
    },
    addTag(newTag) {
      const tag = {
        label: newTag,
        value: newTag,
      }

      this.emitValue(tag)
    },
    onKeydown(e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        this.$nextTick(this.scrollHighlightedIntoView);
      }
    },
    scrollHighlightedIntoView() {
      const dropdown = this.$refs.dropdown;
      if (!dropdown) return;

      const wrapper = dropdown.$el.querySelector('.multiselect__content-wrapper');
      const highlighted = wrapper?.querySelector('.multiselect__option--highlight');

      if (highlighted) {
        highlighted.scrollIntoView({block: 'nearest'});
      }
    }
  }
}
</script>

<style lang="scss">
@import "IDropdown";
</style>
